import jApi from './jApi';

export default {
  getListAutomation(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/automation/fetch', { params })
      .then(res => res);
  },

  getListForm(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/record/form', { params })
      .then(res => res.data);
  },

  getListUser(params) {
    const api = jApi.generateApi();
    return api.post('/user/employee/list-with-pagination', params)
      .then(res => res.data);
  },

  createAutomation(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/studio/automation/set', req)
      .then(res => res.data);
  },

  deleteAutomation(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/automation/delete', { params })
      .then(res => res.data);
  },

  getCountLog(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/automation/log/count', { params })
      .then(res => res.data);
  },

  getListEventName() {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/event/fetch')
      .then(res => res.data);
  },

  getListRunHistory(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/automation/log/list', { params })
      .then(res => res);
  },

  getListActionBlock(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/automation/log/list-action', { params })
      .then(res => res);
  },

  getDetailActionBlock(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/automation/log/detail-action', { params })
      .then(res => res);
  },

  // Job Monitoring
  getJobMonitoringList(id, params) {
    const api = jApi.generateApi();
    return api.get(`nocode-job-monitor/jobs/${id}`, { params })
      .then(res => res.data);
  },

  // Dedicated Job Monitoring
  getDedicatedJobMonitoringList(params) {
    const api = jApi.generateApi();
    return api.get('nocode-dedicated-job/monitor/jobs', { params })
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiAutomation.js